<template>
  <div id="plan" class="content">
    <dl>
      <dt>
        <img width="500" src="../assets/title4@2x.png">
      </dt>
      <dd>
        <p>
          ロードムービーでTHCの4人が訪れたロケ地は、すべておすすめの観光スポット。彼らの足跡はそっくりそのまま、週末で福江島を楽しめる２泊3日の旅プランになるんです。五島に興味を持っていただけたら、早速、やさしくて濃厚な旅の計画を立ててみてはいかがでしょう。
        </p>
      </dd>
    </dl>
    <div id="map">
      <img class="batch" src="../assets/batch@2x.png" alt="">
      <img class="mapImg" src="../assets/map@2x.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plan',
}
</script>

<style scoped>
dl{
  margin-top: 119px;
  display: flex;
  justify-content: center;
  padding: 0 20px;
}
p + p{
  margin-top: 30px;
}
#map{
  margin-top: 85px;
  margin-bottom: 170px;
  text-align: center;
  padding: 0 5px;
  position: relative;
}
.batch{
  position: absolute;
  left: 0;
  top: 0;
  max-width: 70vw;
}
img{
  max-width: 100%;
}
dd{
  margin-top: 104px;
  margin-left: 100px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.15em;
  line-height: 1.8;
  flex-basis: 50%;
  padding: 0 10px;
}
dd > p{
  max-width: 430px;
}
dt{
  flex-basis: 50%;
  text-align: right;
}
@media screen and (max-width:1396px){
  dd{
    margin-left: 50px;
  }
}
@media screen and (max-width:940px){
  dl{
    display: block;
    padding: 0 20px;
  }
  dt{
    text-align: center;
  }
  dd{
    margin: 60px auto 100px;
  }
  dd > p{
     margin-left: auto;
     margin-right: auto;
  }
}
@media screen and (max-width:480px){
  dd{
    min-width: 0;
  }
}
</style>
